import React from 'react';

export default ({ tagValue, title }) => {
    let HeaderValue = `h${tagValue}`;
    let values = {
        1: 'one',
        2: 'two',
        3: 'three',
        4: 'four',
        5: 'five',
        6: 'six'
    };
    return (
        <HeaderValue className={`headline headline--${values[tagValue]}`}>
            {title}
        </HeaderValue>
    );
};



// WEBPACK FOOTER //
// ./src/components/ui/headline.js